import { useSelector } from "store/useSelector";
import { useDispatch } from "react-redux";
import { setFocusRange, setVisibleRange } from "providers/GlobalStateProvider";
import { useEffectOnce, useFocusRange } from "utils/customHooks/genericHooks";
import { useLocation, useNavigate } from "react-router";
import { useWorkScheduleConfigJsonListAtom } from "store/atoms";
import { useEffect } from "react";
import { getIsCypressRunning } from "constants/constants";

export function InitTier0() {
  const dispatch = useDispatch();
  const focusRange = useFocusRange();
  const visibleRange = useSelector(store => store.legacy.visibleRange);
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  // sync ge, lt url params to focusRange
  const ge = searchParams.get("ge");
  const lt = searchParams.get("lt");
  useEffect(() => {
    if (ge && lt) {
      const newFocusRange = { ge: Number(ge), lt: Number(lt) };
      dispatch(setFocusRange(newFocusRange));
    }
  }, [ge, lt, dispatch]);
  useEffect(() => {
    if (focusRange?.ge && focusRange?.lt) {
      searchParams.set("ge", focusRange.ge.toString());
      searchParams.set("lt", focusRange.lt.toString());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusRange]);

  // sync visibleRange to focusRange (used in some data getters)
  useEffect(() => {
    if (focusRange && (!visibleRange || focusRange.ge !== visibleRange.ge)) {
      dispatch(setVisibleRange(focusRange));
    }
  }, [focusRange, visibleRange, dispatch]);

  // add default workSchedule & process to url if missing

  // if there's no workSchedule in the url, default to 1
  const [workSchedulesConfigList] = useWorkScheduleConfigJsonListAtom();
  const firstWorkSchedule = workSchedulesConfigList[0];
  const urlWorkScheduleConfigId = searchParams.get("workSchedule");
  const urlProcessName = searchParams.get("process");
  const navigate = useNavigate();
  useEffectOnce({
    callback: () => {
      if (getIsCypressRunning()) {
        return;
      }
      const workScheduleId = firstWorkSchedule.id;
      const firstProcessInFirstGroup = firstWorkSchedule.processes[0];
      searchParams.set("workSchedule", workScheduleId);
      searchParams.set("process", firstProcessInFirstGroup?.taps[0].name ?? "");
      navigate(`${window.location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });
    },
    shouldRun: Boolean(
      (!urlWorkScheduleConfigId || !urlProcessName) &&
        workSchedulesConfigList.length > 0
    ),
    dependencies: [firstWorkSchedule],
  });

  return null;
}
